const CABINET_ENDPOINTS = {
  STATISTICS: '/cabinet/statistics/',
  STATISTICS_CORE: '/cabinet/statistics-core/',
  NEW_ORDER: '/cabinet/new-order/',
  CREATE_ORDER: '/cabinet/create-order/',
  ORDER_HISTORY: '/cabinet/order-history/',
  BALANCE_HISTORY: '/cabinet/balance-history/',
  BALANCE_DETAILS: '/cabinet/balance-history/:from/:id/',
  INVOICE_HISTORY: '/cabinet/invoice-history/',
  WITHDRAW: '/cabinet/withdraw/',
  SETTINGS: '/cabinet/settings/',
}

export { CABINET_ENDPOINTS }



// WEBPACK FOOTER //
// ./src/js/router/cabinet/ENDPOINTS.js